/*
  Email sign-ups to OneSignal: the article sign-up box, the newsletter forms and the
  contact-page opt-in. Markup, copy and settings are in sections/carol-signup-capture.liquid.

  Every sign-up logs the visitor in with the lowercased email as external_id (the id
  the popup, the guide page and the cart Flow use) and sets signup_source, which puts
  them in the Welcome Journey. The OneSignal Web SDK loads only when someone signs up,
  and push is never asked for.

  Storage keys shared with the welcome popup: carol_welcome_done / _snoozed_at. The
  box waits until the popup has been answered or dismissed, so nobody sees both at once.
  Every storage access is wrapped: private windows and blocked storage throw.
*/
(function () {
  'use strict';

  var cfgEl = document.getElementById('CarolSignupConfig');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var SDK = 'https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js';
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var KEY_DONE = 'carol_signup_done';
  var KEY_SNOOZE = 'carol_signup_snoozed_at';

  function store(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
    } catch (e) { return null; }
    return null;
  }

  function loadSdk() {
    return new Promise(function (resolve, reject) {
      window.OneSignalDeferred = window.OneSignalDeferred || [];
      window.OneSignalDeferred.push(function (OneSignal) { resolve(OneSignal); });
      if (document.querySelector('script[src="' + SDK + '"]')) return;
      var s = document.createElement('script');
      s.src = SDK; s.defer = true;
      s.onerror = function () { reject(new Error('sdk')); };
      document.head.appendChild(s);
      setTimeout(function () { reject(new Error('timeout')); }, 15000);
    });
  }

  var initialised = null;
  function signup(email, source) {
    var addr = String(email || '').trim().toLowerCase();
    if (!EMAIL.test(addr)) return Promise.reject(new Error('email'));
    return loadSdk().then(function (OneSignal) {
      // The welcome popup may already have initialised the SDK on this page; a second
      // init rejects, and that must not stop the sign-up.
      initialised = initialised || OneSignal.init({
        appId: cfg.appId,
        autoResubscribe: false,
        notifyButton: { enable: false },
        welcomeNotification: { disable: true },
        promptOptions: { slidedown: { prompts: [] } }
      }).catch(function () {});
      return initialised.then(function () {
        return OneSignal.login(addr);
      }).then(function () {
        OneSignal.User.addEmail(addr);
        OneSignal.User.addTags({ signup_source: source, region: cfg.region });
        store(KEY_DONE, String(Date.now()));
        if (window.dataLayer) window.dataLayer.push({ event: 'carol_email_signup', signup_source: source, signup_region: cfg.region });
      });
    });
  }
  window.CarolSignup = { signup: signup };

  /* ---- Newsletter forms (footer, /collections/all): Shopify customer forms ---------- */
  // The form still posts to Shopify as before. It is held back until OneSignal has the
  // address, or for 4 seconds at most, so a slow SDK never blocks the sign-up.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM' || form.dataset.cscSent) return;
    var tags = form.querySelector('input[name="contact[tags]"]');
    var email = form.querySelector('input[name="contact[email]"]');
    if (!tags || !email || !/newsletter/.test(tags.value)) return;
    if (!EMAIL.test(email.value.trim())) return; // let the browser/Shopify report it
    e.preventDefault();
    form.dataset.cscSent = '1';
    var go = function () { HTMLFormElement.prototype.submit.call(form); };
    var timer = setTimeout(go, 4000);
    signup(email.value, 'newsletter').catch(function () {}).then(function () { clearTimeout(timer); go(); });
  }, true);

  /* ---- Contact page: opt-in box inside the HubSpot form -------------------------------- */
  function hookHubspot(frame) {
    var doc;
    try { doc = frame.contentDocument; } catch (err) { return false; }
    var form = doc && doc.querySelector('form');
    var submit = form && form.querySelector('input[type="submit"], button[type="submit"]');
    if (!form || !submit || form.querySelector('[data-csc-optin]')) return !!(form && form.querySelector('[data-csc-optin]'));
    var wrap = doc.createElement('div');
    wrap.className = 'hs-form-field';
    wrap.setAttribute('data-csc-optin', '');
    wrap.style.margin = '4px 0 18px';
    // No name attribute: HubSpot must not receive this field.
    wrap.innerHTML = '<label style="display:flex;gap:10px;align-items:flex-start;font-size:14px;line-height:21px;text-transform:none;letter-spacing:0;cursor:pointer">' +
      '<input type="checkbox" style="width:18px;height:18px;margin:2px 0 0;flex:none"><span></span></label>';
    // HubSpot styles every label as an uppercase mono caption; this is a sentence, so it
    // takes the typeface and colour of the form's own inputs instead.
    var span = wrap.querySelector('span');
    var field = form.querySelector('input[type="email"], textarea') || form;
    var fcs = doc.defaultView.getComputedStyle(field);
    // The form's label rules are !important, so these must be too.
    var look = { 'text-transform': 'none', 'letter-spacing': '0', 'font-weight': '400', 'font-size': '15px',
      'line-height': '22px', 'font-family': fcs.fontFamily, 'color': fcs.color };
    Object.keys(look).forEach(function (k) { span.style.setProperty(k, look[k], 'important'); });
    span.textContent = cfg.contactLabel;
    var submitRow = submit.closest('.hs_submit') || submit.parentNode;
    submitRow.parentNode.insertBefore(wrap, submitRow);
    form.addEventListener('submit', function () {
      var box = wrap.querySelector('input');
      var email = form.querySelector('input[name="email"]');
      if (box.checked && email && EMAIL.test(email.value.trim())) signup(email.value, 'contact').catch(function () {});
    }, true);
    return true;
  }

  if (cfg.contactOptIn && /\/pages\/contact\b/.test(location.pathname)) {
    var tries = 0;
    var poll = setInterval(function () {
      var frame = document.querySelector('iframe.hs-form-iframe');
      if ((frame && hookHubspot(frame)) || ++tries > 60) clearInterval(poll);
    }, 500);
  }

  /* ---- Article sign-up box -------------------------------------------------------------- */
  var box = document.getElementById('CarolSignupFlyout');
  if (!cfg.flyout || !box) return;

  function welcomeAnswered() {
    return !!(store('carol_welcome_done') || store('carol_welcome_snoozed_at'));
  }
  function snoozed() {
    if (store(KEY_DONE) || store('carol_welcome_done')) return true;
    var at = parseInt(store(KEY_SNOOZE) || '0', 10);
    return at && (Date.now() - at) < cfg.snoozeDays * 864e5;
  }
  function popupOpen() {
    var p = document.getElementById('CarolWelcomePopup');
    return !!(p && !p.hidden);
  }

  var form = box.querySelector('[data-csc-form]');
  var input = form.elements.email;
  var error = box.querySelector('[data-csc-error]');
  var shown = false;
  var submitted = false;

  function open() {
    if (shown || snoozed() || !welcomeAnswered() || popupOpen()) return;
    shown = true;
    box.hidden = false;
    requestAnimationFrame(function () { box.classList.add('is-open'); });
    window.removeEventListener('scroll', onScroll);
    if (window.dataLayer) window.dataLayer.push({ event: 'carol_signup_box_view' });
  }

  function close() {
    if (!submitted) store(KEY_SNOOZE, String(Date.now()));
    box.classList.remove('is-open');
    setTimeout(function () { box.hidden = true; }, 260);
  }

  function onScroll() {
    var doc = document.documentElement;
    var share = (window.scrollY + window.innerHeight) / Math.max(doc.scrollHeight, 1);
    if (share >= cfg.scrollShare) open();
  }

  box.addEventListener('click', function (e) { if (e.target.closest('[data-csc-close]')) close(); });
  box.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  input.addEventListener('input', function () { input.removeAttribute('aria-invalid'); error.textContent = ''; });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!EMAIL.test(input.value.trim())) {
      input.setAttribute('aria-invalid', 'true');
      error.textContent = cfg.msgEmail || 'Please enter a valid email address.';
      input.focus();
      return;
    }
    var button = form.querySelector('.csc__submit');
    button.disabled = true;
    signup(input.value, 'blog').then(function () {
      submitted = true;
      box.querySelector('[data-csc-ask]').hidden = true;
      var done = box.querySelector('[data-csc-done]');
      done.hidden = false;
      done.focus({ preventScroll: true });
      setTimeout(close, 6000);
    }).catch(function () {
      button.disabled = false;
      error.textContent = cfg.msgError || 'Something went wrong on our side. Please try again in a moment.';
    });
  });

  // ?csc_test=1 opens the box at once for a test, whatever the stored state.
  if (cfg.test || /[?&]csc_test=1\b/.test(location.search)) {
    try { ['carol_signup_done', 'carol_signup_snoozed_at'].forEach(function (k) { window.localStorage.removeItem(k); }); } catch (err) {}
    shown = false;
    box.hidden = false;
    requestAnimationFrame(function () { box.classList.add('is-open'); });
    return;
  }
  if (snoozed()) return;
  window.addEventListener('scroll', onScroll, { passive: true });
})();
